import { mapGetters, mapActions } from 'vuex';

const exCreditCard = {

  methods: {
    ...mapActions('eCCTransactions', [
      'getCreditCards',
    ]),
  },
  computed: {
    ...mapGetters('eCCTransactions', ['ccDetails']),
    ...mapGetters('users', [
      'me',
      'userCompanyId',
      'userCompanyName',
    ]),
  },
  watch: {

  },
};

export default exCreditCard;
